import BaseService from '../base';
import { IBlindBoxRecordRequest, ISendRequest } from './types';

class GiftService extends BaseService {
  getPreloadConfig() {
    const url = '/web/live/treasure/preload';
    const config = { url };
    if (import.meta.env.SSR) {
      config.headers = {
        'accept-encoding': 'gzip'
      };
    }
    return this.get(config);
  }

  getPanel() {
    const url = '/web/live/treasure/panel';
    return this.get({ url });
  }

  send({ treasure_id, room_id, number }) {
    const url = '/web/live/treasure/send';
    const data: ISendRequest = {
      treasure_id,
      room_id,
      number,
    };
    return this.postForm({ url, data });
  }

  getBalance() {
    const url = '/web/live/treasure/balance';
    return this.get({ url });
  }

  preloadAnimation(resourceUrl: string) {
    return this.get({
      url: resourceUrl,
      responseType: 'blob',
      withCredentials: false,
      timeout: 30 * 1000
    });
  }

  getBlindBoxRecord(params: IBlindBoxRecordRequest) {
    const url = '/web/live/treasure/blindbox/record';
    return this.get({ url, params });
  }
}

const giftService = new GiftService();

export default giftService;
